/**
 * vivid 스킨 — 생동감·선명.
 *
 * 감성 키워드:
 * - 큰 borderRadius (16+) + 두꺼운 border
 * - primary 버튼·카드에 그라데이션(overlay CSS 에서 처리)
 * - 굵은 폰트 웨이트
 *
 * CSS overlay 위치: styles/skins.css — `body[data-skin="vivid"]` 블록
 */
import type { SkinDef } from './types'

export const vividSkin: SkinDef = {
  key: 'vivid',
  label: '비비드',
  description: '그라데이션과 선명한 색채',
  swatch: { bg: '#0f172a', fg: '#f8fafc', accent: '#f472b6' },
  token: {
    borderRadius: 16,
    borderRadiusLG: 20,
    borderRadiusSM: 12,
    fontWeightStrong: 700
  },
  componentDefaults: {
    Card: {
      borderRadiusLG: 20
    },
    Button: {
      borderRadius: 16,
      fontWeight: 600
    },
    Tag: {
      borderRadiusSM: 12
    }
  }
}
